// extracted by mini-css-extract-plugin
export default {"root":"_19BiZ","discount-label":"_1uCqZ","discountLabel":"_1uCqZ","price":"nAwuz","old-price":"_3g3H_","oldPrice":"_3g3H_"};